import React, { useState } from "react";
import "./Banner_Btn_Component.css";
import Green_Btn from "../../common_components/common_btn/green_btn/Green_Btn";
import Alert_Modal from "../../common_components/common_modal/alert_modal/Alert_Modal";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";

const Banner_Btn_Component = ({ addBanners }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <section className="Banner_Btn_Component">
      <div className="banner_div">
        <Swiper
          className="mySwiper"
          slidesPerView={1}
          loop={true}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
        >
          {addBanners?.map((banner, index) =>
            banner?.image ? (
              <SwiperSlide key={index}>
                <div className="img_div">
                  <img
                    src={process.env.REACT_APP_IMG_URL + banner.image}
                    alt={`banner-${index}`}
                    className="banner_img"
                  />
                </div>
              </SwiperSlide>
            ) : null
          )}
        </Swiper>
      </div>

      {/* Example: Show CTA button over banner */}
      {/* <div className="content_div">
        <p className="title_text">Paan Corner</p>
        <p className="subtext">
          All delighting flavours now on your finger tips!
        </p>
        <div className="shop_btn">
          <Green_Btn
            btn_name="Shop Now"
            onClick={() => {
              setShowModal(true);
            }}
          />
        </div>
      </div> */}

      {/* Modal Example */}
      {/* <Alert_Modal
        show={showModal}
        setShowModal={setShowModal}
        onHide={() => setShowModal(false)}
        successText="Order canceled successfully!"
      /> */}
    </section>
  );
};

export default Banner_Btn_Component;
